import { parseMimeType } from "@scalar/helpers/http/mime-type";
//#region src/v2/blocks/response-block/helpers/resolve-response-content-type.ts
/**
* Browser fetch uses text/plain;charset=UTF-8 as the default body type
* when the response does not include a Content-Type header.
*/
var DEFAULT_RESPONSE_CONTENT_TYPE = "text/plain;charset=UTF-8";
/**
* Resolve the response content type with a consistent fallback.
*/
var resolveResponseContentType = (contentType) => contentType ?? "text/plain;charset=UTF-8";
/**
* Parse the effective response MIME type using the fallback content type.
*/
var resolveResponseMimeType = (contentType) => parseMimeType(resolveResponseContentType(contentType));
//#endregion
export { DEFAULT_RESPONSE_CONTENT_TYPE, resolveResponseContentType, resolveResponseMimeType };

//# sourceMappingURL=resolve-response-content-type.js.map